export default __webpack_public_path__ + "static/media/money-credit-card.b0cb3115.png";